import { render, staticRenderFns } from "./Vod.vue?vue&type=template&id=2c27dcc4&scoped=true&"
import script from "./Vod.vue?vue&type=script&lang=js&"
export * from "./Vod.vue?vue&type=script&lang=js&"
import style0 from "./Vod.vue?vue&type=style&index=0&id=2c27dcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27dcc4",
  null
  
)

export default component.exports